<template>
    <div>                   
        <frame-surface-opening-side> </frame-surface-opening-side>
         <v-divider class="my-5"></v-divider>
        <frame-surface-counter-opening-side> </frame-surface-counter-opening-side>
        <v-divider class="my-5"></v-divider>
        <frame-surface-gloss/>
        <v-divider class="my-5"></v-divider>
    </div>
</template>
<script>
import Vue from 'vue';  
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import FrameSurfaceOpeningSide from './FrameSurfaceOpeningSide.vue';
import FrameSurfaceCounterOpeningSide from './FrameSurfaceCounterOpeningSide.vue';
import FrameSurfaceGloss from "@/views/productConfigurator/doorSurface/FrameSurfaceGloss";

export default Vue.extend({
        name: 'FrameSurface',
         components: {
            'frame-surface-opening-side' : FrameSurfaceOpeningSide,
             'frame-surface-counter-opening-side' : FrameSurfaceCounterOpeningSide,
             'frame-surface-gloss' : FrameSurfaceGloss
         },
        props: {
            characteristic: Object,            
        },
        data() {
            return {
                
            }
        },
        computed: {            
            // ...mapGetters(['getCurrentDoorConfiguration']),
            // ...mapGetters('measureModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue' ]),
        },
        methods: {
            // ...mapActions(['updateDoorConfiguration']),
            // ...mapActions('measureModule', ['addCharacterisitc']),
        }, 
        mounted() {
            
        },
    }) 
</script>
<style lang="scss">
.violet-text{
    color: #65006c !important;
}
</style>